<mobi-content-section
  [id]="
    (anchorId()
      ? anchorId()
      : ('damage_examples_paramenter_name'
        | texts: { context: 'frontend', default: 'schadenbeispiele' })
    ) | anchorFormatter
  "
  [content]="content"
>
  <ng-template #content>
    @if (title()) {
      <h2 class="view-enter-animation">
        {{ title() }}
      </h2>
    }

    <div class="mobi-ui-grid is-gap-md is-align-stretch">
      @for (example of damageExamples(); track example.id) {
        <div
          class="mobi-ui-col-1/1 md:mobi-ui-col-1/2 lg:mobi-ui-col-1/3 view-enter-animation"
        >
          @if (breakpoint.mdAndLarger()) {
            <div
              class="mobi-ui-card-major mobi-ui-animation-slide-up-init mobi-ui-animation-slide-up-hover h-full"
            >
              @if (example.icon; as icon) {
                <mobi-ui-icon-major
                  size="md"
                  [name]="icon.symbol"
                  class="mobi-ui-text-inked"
                />
              }
              <h3 class="mobi-ui-text-inked mobi-ui-font-h5 mobi-ui-padding-y-sm">
                {{ example.damageLabel }}
              </h3>
              <mobi-ui-carousel-major
                [maxColumns]="1"
                class="is-controls-bottom hide-indicator-bar [&_.items-wrapper]:!ml-0 [&_.items-wrapper]:!px-0 [&_.items-wrapper]:!w-full"
              >
                @for (slide of example.damageExamples; track i; let i = $index) {
                  <div>
                    <span class="block mobi-ui-font-bold mobi-ui-margin-b-xxxs">
                      {{ slide.first }}
                    </span>
                    <mobi-text class="mobi-ui-font-size-200" [data]="slide.second" />
                  </div>
                }
              </mobi-ui-carousel-major>
            </div>
          }
          @if (breakpoint.smMax()) {
            <button
              class="mobi-ui-card-major is-clickable is-row !items-center"
              (keyup)="openOverlay(example)"
              (click)="openOverlay(example)"
            >
              @if (example.icon; as icon) {
                <mobi-ui-icon-major
                  [name]="icon.symbol"
                  class="mobi-ui-text-inked mr-[8px] shrink-0"
                />
              }
              <h3 class="mobi-ui-text-inked mobi-ui-font-h5 !py-0 !mt-0 text-left">
                {{ example.damageLabel }}
              </h3>
            </button>
          }
        </div>
      }
    </div>

    @if (damageExampleCta() && damageExampleCta() | extractUrl) {
      <div class="flex justify-center mobi-ui-padding-t-md view-enter-animation">
        <mobi-icon-cta
          class="block"
          [isPrimary]="true"
          [url]="damageExampleCta() | extractUrl | calcUrl: calcUrl()"
          [target]="damageExampleCta()!.options?.attributes?.target"
          [title]="damageExampleCta()!.title"
          icon="calculator"
        ></mobi-icon-cta>
      </div>
    }
  </ng-template>
</mobi-content-section>

@if (overlayOpen() && currentExample()) {
  <mobi-overlay-small
    [isOpen]="overlayOpen()"
    [content]="overlayContent"
    (closeOverlay)="overlayOpen.set(false)"
  >
    <ng-template #overlayContent>
      <div>
        <h3 class="mobi-ui-text-inked mobi-ui-font-h2 !mt-0">
          {{ currentExample()!.damageLabel }}
        </h3>
        @if (currentExample()!.damageExamples.length > 1) {
          <mobi-ui-carousel-major
            [maxColumns]="1"
            class="force-indicator-and-buttons [&_.items-wrapper]:!pt-2"
          >
            @for (item of currentExample()!.damageExamples; track $index) {
              <div class="mobi-ui-card-major">
                <div class="mobi-ui-card-content-major">
                  <span class="mobi-ui-font-bold">{{ item.first }}</span>
                  <mobi-text class="mobi-ui-font-size-200" [data]="item.second" />
                </div>
              </div>
            }
          </mobi-ui-carousel-major>
        } @else if (currentExample()!.damageExamples.length === 1) {
          <div class="mobi-ui-card-major">
            <div class="mobi-ui-card-content-major">
              <span class="mobi-ui-font-bold">{{
                currentExample()!.damageExamples[0].first
              }}</span>
              <mobi-text
                class="mobi-ui-font-size-200"
                [data]="currentExample()!.damageExamples[0].second"
              />
            </div>
          </div>
        }
      </div>
    </ng-template>
  </mobi-overlay-small>
}
